<script>
import { mapState } from "vuex";

export default {
  name: "IncCopyright",
  data() {
    return {
      isKuokkoMobileApp: !!window.isKuokkoMobileApp
    };
  },
  computed: {
    ...mapState("restaurant", {
      locale: state => state.locale,
      locali: state => state.locali
    }),
    restaurantName() {
      if (this.locale && this.locale.nome_locale) {
        return this.locale.nome_locale;
      }
      return "";
    }
  },
  methods: {
    handleOpen(type) {
      this.$emit("open-privacy-modal", type);
    }
  }
};
</script>
<template>
  <div class="container">
  <div v-if="!isKuokkoMobileApp" class="d-flex flex-md-row flex-column justify-content-center justify-content-md-between align-items-center py-2">
    <div class="color-footer text-center text-md-start">
      <span v-if="restaurantName">{{ restaurantName }} - </span>
      <a href="#" @click.prevent="handleOpen('privacy')" class="a-nobkg">{{ $t('layout_privacy') }}</a> |
      <a href="#" @click.prevent="handleOpen('termini')" class="a-nobkg">{{ $t('termini_condizioni.titolo') }}</a> |
      <a href="#" @click.prevent="handleOpen('cookie')" class="a-nobkg">Cookie</a>
    </div>
    <div class="color-footer f1 text-center mt-3 mt-md-0">Powered by
        <a href="http://www.kuokko.com" target="_blank">
            <img src="/img/be/logo-kuokko.svg" width="70">
        </a>
    </div>
  </div>
  </div>
</template>
